import * as React from "react";
const SvgInfo = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.456 12A9.544 9.544 0 0 0 12 21.544 9.544 9.544 0 0 0 21.544 12a9.544 9.544 0 1 0-19.088 0M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M12.822 16.775v-5.672a.924.924 0 0 0-1.848 0v5.672a.924.924 0 0 0 1.848 0M11.898 8.627a1.163 1.163 0 1 0 0-2.325 1.163 1.163 0 0 0 0 2.325"
  }
));
export default SvgInfo;
